import React from 'react';
import * as XLSX from 'xlsx'
import Loader from './../../../component/common/Loader';
import CONSTANT from '../../../constant';
import Header from '../../../component/common/LeaveHeader';

import { updateUserLeave } from '../../../actions/LeaveAction';
import { getUserSummaryList } from '../../../actions/UserAction';
import { getLeaveType } from '../../../actions/MasterAction';
import { onChange, validateForm, } from '../../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            list: [],
            employeeList: [],
            leaveTypeList: [],
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        getUserSummaryList().then((res: any) => {
            this.setState({ employeeList: res.result });
        });

        getLeaveType().then((res: any) => {
            this.setState({ leaveTypeList: res.result });
        });
    }

    render() {
        const { list, showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Bulk Upload Leave Balance</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">Upload Excel</div>
                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Excel File *</label>
                                                        <input
                                                            type="file"
                                                            className='form-control p-1'
                                                            onChange={this.onFileChange}
                                                        />
                                                    </div>
                                                    <a href="/excel/bulk-leave-balance.xlsx">Click here to download sample</a>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-10"></div>
                                                <div className="col-md-2">
                                                    <button className="btn btn-sm submit-button btn-block" type="submit">Upload</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Employee Number</th>
                                                <th scope="col" title="Casual leave">CL</th>
                                                <th scope="col" title="RH">RH</th>
                                                <th scope="col" title="Encashable">EL</th>
                                                <th scope="col" title="Non-Encashable">NON-EL</th>
                                                <th scope="col" title="HPL">HPL</th>
                                            </tr>
                                            {
                                                list === undefined && <tr>
                                                    <td colSpan={10} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.length === 0 && <tr>
                                                    <td colSpan={10} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.map((item: any, index: number) => {
                                                    return (
                                                        <tr className="c-pointer" key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.status === undefined ? '-' : (item.status === true ? <i className="fa fa-check-circle text-success" /> : <i className="fa fa-times-circle text-danger" />)}</td>
                                                            <td>{item.employeeNumber}</td>
                                                            <td>{`${item.clUsed}/${item.clTotal}`}</td>
                                                            <td>{`${item.rhUsed}/${item.rhTotal}`}</td>
                                                            <td>{`${item.elUsed}/${item.elTotal}`}</td>
                                                            <td>{`${item.nonelUsed}/${item.nonelTotal}`}</td>
                                                            <td>{`${item.hplUsed}/${item.hplTotal}`}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div >
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.value;
        onChange(this, name, value);
    }

    onFileChange = (evt: any) => {
        var context = this;
        var files = evt.target.files, f = files[0];
        var reader = new FileReader();
        reader.onload = (e: any) => {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, { type: 'array' });
            var json = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
            context.setState({ list: json }, () => {
            })
        };
        reader.readAsArrayBuffer(f);
    }

    validateExcel = () => {
        const { list, employeeList } = this.state;
        for (let i = 0; i < list.length; i++) {
            const employeeDetail = employeeList.filter((j: any) => j.employeeNumber === list[i].employeeNumber);
            if (employeeDetail.length === 0) {
                alert(`Couldnt find employee id ${list[i].employeeNumber} in the system.`);
                return false;
            }
        }
        if (list.length === 0) {
            alert('Please select a file to upload');
            return false;
        }
        return true;
    }

    onSubmit = async (e: any) => {
        e.preventDefault();
        const { list, employeeList } = this.state;
        const leaveBalance = JSON.parse(JSON.stringify(list));

        if (this.validateExcel()) {
            const parsedLeaveBalance = leaveBalance.map((item: any) => {
                const employeeDetail = employeeList.filter((i: any) => i.employeeNumber === item.employeeNumber)[0];
                const model: any = {
                    userCode: employeeDetail.code,
                    leaveBalance: []
                }
                model.leaveBalance.push({ code: CONSTANT.static.leaveType.cl, used: item.clUsed, total: item.clTotal });
                model.leaveBalance.push({ code: CONSTANT.static.leaveType.el, used: item.elUsed, total: item.elTotal });
                model.leaveBalance.push({ code: CONSTANT.static.leaveType.nonel, used: item.nonelUsed, total: item.nonelTotal });
                model.leaveBalance.push({ code: CONSTANT.static.leaveType.hpl, used: item.hplUsed, total: item.hplTotal });
                // model.leaveBalance.push({ code: CONSTANT.static.leaveType.cml, used: item.cmlUsed, total: item.cmlTotal });
                model.leaveBalance.push({ code: CONSTANT.static.leaveType.rh, used: item.rhUsed, total: item.rhTotal });
                return model;
            });
            this.callAPI(parsedLeaveBalance);
        }
    }

    sleep = (ms: any) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    callAPI = async (excelData: any) => {
        let self = this;
        let countPro = 0;
        this.setState({ showLoader: true })
        for await (const data of excelData) {
            try {
                await self.sleep(1000);
                updateUserLeave(data).then((res: any) => {
                    if (res.status === CONSTANT.static.apiStatus.success) {
                        const employeeDetail = this.state.employeeList.filter((i: any) => i.code === res.result.userCode)[0];
                        const updatedList = this.state.list.map((item: any) => {
                            if (item.employeeNumber === employeeDetail.employeeNumber) {
                                item.status = true
                            }
                            return item;
                        });
                        this.setState({ list: updatedList });
                    }
                    countPro += 1;
                    if (countPro === excelData.length) {
                        self.setState({ showLoader: false });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        }
    }
}

export default ComponentName;